module.exports = __webpack_public_path__ + "src/assets/img/herocta--med.08479147.png";